import React, { useEffect, useRef, useState } from "react";
import FormInput from "../../Input/FormInput";
import Input from "../../Input/Input";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import Location from "../../Input/Location";
import "../../../stylesheets/Employer.css";
import axiosInstance from "../../../services/api/axiosInstance";
import toast from "react-hot-toast";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { sha256 } from 'js-sha256';





const PartnerSignupForm = ({
  setPartnerVisibleResendLink,
  partnerTimeLeft,
  setPartnerTimeLeft,
  setPartnerResendMailAccessToken,
  setPartnerEmailIdForResendEmail,
}) => {





  const [submitted, setSubmitted] = useState(false);

  const [loading, setLoading] = useState(false);

  const [allFieldsEmpty, setAllFieldsEmpty] = useState(false)

  const [agreeTerms, setAgreeTerms] = useState(false)

  const [partnerPasswordErrorMessage, setPartnerPasswordErrorMessage] = useState("")
  const [partnerConfirmPasswordErrorMessage, setPartnerConfirmPasswordErrorMessage] = useState("")

  const isPartnerSignup = true

  const [locationFieldEmpty, setLocationFieldEmpty] = useState(false)


  const [partnerSignupInputValues, setPartnerSignupInputValues] = useState({
    firstName: "",
    lastName: "",
    nameOfOrganization: "",
    title: "",
    typeOfPartner: "",
    industrySector: "",
    officialEmail: "",
    website: "",
    countryCode: "",
    mobileNumber: "",
    password: "",
    confirmPassword: "",
  });

  const [countryCode, setCountryCode] = useState('us')
  const [dialCode, setDialCode] = useState("")

  const [location, setLocation] = useState({
    city: "",
    country: "",
  });

  const formRef = useRef(null);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const [emailAutoFocus, setEmailAutoFocus] = useState(false)


  const [userNativeCountry, setUserNativeCountry] = useState("")
  const [userCurrentCountry, setUserCurrentCountry] = useState("")


  const employerSignupInputFields = [
    {
      id: 1,
      name: "firstName",
      type: "text",
      placeholder: "First Name",
      label: "First Name",
      errorMessage: "Please enter a valid first name",
      required: true,
      className: "form-control",
      dataTestid: "firstName",
      role: "firstName",
      alt: "firstName",
    },
    {
      id: 2,
      name: "lastName",
      type: "text",
      placeholder: "Lastname",
      label: "Last Name",
      errorMessage: "Please enter a valid last name",
      required: true,
      className: "form-control",
      dataTestid: "lastName",
      alt: "lastName",
    },
    {
      id: 3,
      name: "nameOfOrganization",
      type: "text",
      placeholder: "Organization Name",
      label: "Organization Name",
      errorMessage: "Please enter the organization",
      required: true,
      className: "form-control",
      dataTestid: "nameOfOrganization",
      alt: "nameOfOrganization",
    },
    {
      id: 4,
      name: "title",
      type: "text",
      placeholder: "Title",
      label: "Title",
      errorMessage: "Please enter the title",
      required: true,
      className: "form-control",
      dataTestid: "title",
      alt: "title",
    },
    {
      id: 5,
      name: "typeOfPartner",
      type: "text",
      placeholder: "Type of partner",
      label: "Type of partner",
      errorMessage: "Please enter type of organization",
      required: true,
      pattern: "^[A-Za-z0-9]{1,16}$",
      className: "form-control",
      dataTestid: "typeOfPartner",
      alt: "typeOfPartner",
    },
    {
      id: 6,
      name: "industrySector",
      type: "text",
      placeholder: "Industry Sector",
      label: "Industry Sector",
      errorMessage: "Please enter industry sector",
      required: true,
      pattern: "^[A-Za-z0-9]{1,16}$",
      className: "form-control",
      dataTestid: "industrySector",
      alt: "industrySector",
    },
    {
      id: 7,
      name: "officialEmail",
      type: "email",
      placeholder: "Official email",
      label: "Official email",
      required: true,
      className: "form-control",
      alt: "officialEmail",
      dataTestid: "officialEmail",
    },
    {
      id: 8,
      name: "website",
      type: "text",
      placeholder: "Website",
      label: "Website",
      errorMessage: "Please enter the website",
      required: true,
      className: "form-control",
      dataTestid: "website",
      alt: "website",
    },
    {
      id: 9,
      name: "mobileNumber",
      type: "number",
      placeholder: "Mobile Number",
      label: "Mobile Number",
      required: true,
      className: "form-control",
      errorMessage: "Please enter a valid phone number",
      alt: "mobileNumber",
      pattern: "^([+]d{2})?d{10}$",
      dataTestid: "mobileNumber",
    },
    {
      id: 10,
      name: "location",
      type: "text",
      placeholder: "Location",
      label: "Location",
      // required: true,
      className: "form-control",
      errorMessage: "Please select a location from the drop-down menu",
      // pattern: "^.{4,}",
      alt: "location",
      dataTestid: "location",
    },
    {
      id: 11,
      name: "password",
      type: showPassword ? "text" : "password",
      placeholder: "Password",
      label: "Password",
      required: true,
      className: "form-control",
      alt: "password",
      dataTestid: "password",
    },
    {
      id: 12,
      name: "confirmPassword",
      type: showConfirmPassword ? "text" : "password",
      placeholder: "Confirm Password",
      label: "Confirm Password",
      required: true,
      className: "form-control",
      alt: "confirmPassword",

    },
  ];

  const typesOfPartner = [
    {
      id: 1,
      type: "Search firm",
    },

    {
      id: 2,
      type: "Skill platform",
    },

    {
      id: 3,
      type: "Assessment company",
    },

    {
      id: 4,
      type: "Coaching and mentoring firm",

    },
    {
      id: 5,
      type: "Learning and Development Organization",

    },
    {
      id: 6,
      type: "Others",
    },
  ];

  const industrySectors1 = [
    {
      id: 1,
      industry: "Agriculture and Natural Resources",
    },
    {
      id: 2,
      industry: "Arts, Media and Entertainment",
    },
    {
      id: 3,
      industry: "Building and Construction Trades",
    },
    {
      id: 4,
      industry: "Business and Finance",
    },
    {
      id: 5,
      industry: "Defense and Armed Forces",
    },
    {
      id: 6,
      industry: "Education, Child Development and Family Services",
    },
    {
      id: 7,
      industry: "Energy, Environment and Utilities",
    },
    {
      id: 8,
      industry: "Engineering and Architecture",
    },
    {
      id: 9,
      industry: "Fashion and Interior Design",
    },
    {
      id: 10,
      industry: "Health science and Medical Technology ",
    },
    {
      id: 11,
      industry: "Hospitality, Tourism and Recreation",
    },
    {
      id: 12,
      industry: "Information and Communication Technology",
    },
    {
      id: 13,
      industry: "Manufacturing and Product Development",
    },
    {
      id: 14,
      industry: "Marketing, Sales and Services",
    },
    {
      id: 15,
      industry: "Public Services",
    },
    {
      id: 16,
      industry: "Transportation",
    },
    {
      id: 17,
      industry: "Non-profit organizations",
    },
    {
      id: 18,
      industry: "Others",
    },
  ];

  const industrySectors = [
    {
      id: 1,
      industry: "Agriculture",
    },
    {
      id: 2,
      industry: "Arts",
    },
    {
      id: 3,
      industry: "Construction",
    },
    {
      id: 4,
      industry: "Consumer Goods",
    },
    {
      id: 5,
      industry: "Corporate Services",
    },
    {
      id: 6,
      industry: "Design",
    },
    {
      id: 7,
      industry: "Education",
    },
    {
      id: 8,
      industry: "Energy and Mining",
    },
    {
      id: 9,
      industry: "Entertainment",
    },
    {
      id: 10,
      industry: "Finance",
    },
    {
      id: 11,
      industry: "Hardware and Networking",
    },
    {
      id: 12,
      industry: "Health Care",
    },
    {
      id: 13,
      industry: "Legal",
    },
    {
      id: 14,
      industry: "Manufacturing",
    },
    {
      id: 15,
      industry: "Media and Communications",
    },
    {
      id: 16,
      industry: "Nonprofit",
    },
    {
      id: 17,
      industry: "Others",
    },
    {
      id: 18,
      industry: "Professional Services",
    },
    {
      id: 19,
      industry: "Public Administration",
    },
    {
      id: 20,
      industry: "Public Safety",
    },
    {
      id: 21,
      industry: "Real Estate",
    },
    {
      id: 22,
      industry: "Recreation and Travel",
    },
    {
      id: 23,
      industry: "Retail",
    },
    {
      id: 24,
      industry: "Software and IT Services",
    },
    {
      id: 25,
      industry: "Transportation and Logistics",
    },
    {
      id: 26,
      industry: "Wellness and Fitness",
    },
  ];


  const handlePhoneInput = (e, phone, contactno) => {

    setUserNativeCountry(phone.name)


    setPartnerSignupInputValues({
      ...partnerSignupInputValues,
      mobileNumber: e.slice(phone.dialCode.length),
      countryCode: phone.dialCode,
    });

    setCountryCode(phone.dialCode)
    setDialCode(phone.dialCode)
  };

  const handleTypeOfPartner = (type) => {
    setPartnerSignupInputValues((prevState) => ({
      ...prevState,
      typeOfPartner: type,
    }));
  };

  const handleIndustrySector = (industry) => {
    setPartnerSignupInputValues((prevState) => ({
      ...prevState,
      industrySector: industry,
    }));
  };


  const handleLocation = (selectedLocation) => {

    const countryComponent = selectedLocation.find(component => component.types.includes('country'));


    if (countryComponent) {
      setUserCurrentCountry(countryComponent.long_name)

      if (selectedLocation) {
        setLocation({
          city: selectedLocation[0].long_name,
          country: countryComponent.long_name,
        });
      }
    }
  };


  useEffect(() => {
    if (partnerTimeLeft === 0) {
      setPartnerTimeLeft(null);
    }

    if (!partnerTimeLeft) return;

    const intervalId = setInterval(() => {
      setPartnerTimeLeft(partnerTimeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [partnerTimeLeft]);



  const regex = /^[a-zA-Z0-9._%+-]+@(?!gmail\.com$|yahoo\.com$|hotmail\.com$|rediffmail\.com$)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


  const handleCreateAccount = async (e) => {
    e.preventDefault();

    if (
      partnerSignupInputValues.firstName === "" ||
      partnerSignupInputValues.lastName === "" ||
      partnerSignupInputValues.nameOfOrganization === "" ||
      partnerSignupInputValues.title === "" ||
      partnerSignupInputValues.typeOfPartner === "" ||
      partnerSignupInputValues.industrySector === "" ||
      partnerSignupInputValues.officialEmail === "" ||
      countryCode === "" ||
      partnerSignupInputValues.mobileNumber === "" ||
      partnerSignupInputValues.password === "" ||
      partnerSignupInputValues.confirmPassword === ""

    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    }

    else if (location.country === "" || location.city === "") {
      setLocationFieldEmpty(true)
      toast.error('Kindly select a location from the drop-down menu')
      return
    }

    else if (
      agreeTerms === false
    ) {
      toast("Please select the checkbox", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    }
    else if (
      partnerSignupInputValues.password.length < 8 ||
      partnerSignupInputValues.confirmPassword.length < 8
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    }

    else if (partnerSignupInputValues.password !== partnerSignupInputValues.confirmPassword) {
      setPartnerConfirmPasswordErrorMessage("Confirm password must match the password field")
    }




    else {
      if (userNativeCountry.toLowerCase() === userCurrentCountry.toLowerCase()) {
        const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#\$%\^&\*]).{8,20}$/;
        if (regex.test(partnerSignupInputValues.password)) {
          handleCreateAccountConfirmation(e)
        }
        else {
          setPartnerPasswordErrorMessage("Password must be at least 8 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character");
        }

      } else {
        const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#\$%\^&\*]).{8,20}$/;
        if (regex.test(partnerSignupInputValues.password)) {
          document.getElementById('coutryLocationMatchModalOpen').click()
          return
        }
      }
    }


  };


const handleCreateAccountConfirmation = async (e) => {
  e.preventDefault();
  const partnerRegisterParameters = {
    first_name: partnerSignupInputValues.firstName.trim(),
    last_name: partnerSignupInputValues.lastName.trim(),
    company_name: partnerSignupInputValues.nameOfOrganization,
    title: partnerSignupInputValues.title,
    partner_type: partnerSignupInputValues.typeOfPartner,
    sector: partnerSignupInputValues.industrySector,
    email_id: partnerSignupInputValues.officialEmail,
    website: partnerSignupInputValues.website,
    country: location.country,
    country_code: partnerSignupInputValues.mobileNumber === "" ? "us" : countryCode,
    contact_number: partnerSignupInputValues.mobileNumber,
    city: location.city,
    user_pwd: sha256(partnerSignupInputValues.confirmPassword),
  };

  try {

    document.getElementById('locationConfirmationModalClose').click()
    setLoading(true);
    const response = await axiosInstance.post(
      "/partner_register",
      partnerRegisterParameters
    );

    if (response.data.error_code === 0) {

      setPartnerSignupInputValues({
        mobileNumber: null,
      });

      setLocationFieldEmpty(false)


      setCountryCode('us')
      setDialCode('us')

      formRef.current.reset();

      setPartnerSignupInputValues({
        firstName: "",
        lastName: "",
        typeOfPartner: "",
        industrySector: ""
      })

      setLocation({
        city: "",
        country: "",
      })
      setAllFieldsEmpty(true)

      setPartnerTimeLeft(90)
      setPartnerVisibleResendLink(true)
      setPartnerResendMailAccessToken(response.data.data.access_token)
      setPartnerEmailIdForResendEmail(partnerSignupInputValues.officialEmail)

      toast.success(response.data.message, {
        duration: 4000
      });
    }
    setLoading(false);
  } catch (err) {
    console.log(err);
  }
}


const onChange = (e) => {

  if (e.target.name === "password") {

    setPartnerSignupInputValues({
      ...partnerSignupInputValues,
      password: e.target.value,
    });
    const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#\$%\^&\*]).{8,20}$/;

    if (e.target.value.length >= 8 && regex.test(e.target.value)) {
      setPartnerPasswordErrorMessage("");
    } else if (e.target.value.length < 8) {
      setPartnerPasswordErrorMessage("Password must be at least 8 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character");
      return
    } else {
      setPartnerPasswordErrorMessage("Password must be at least 8 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character");
      return
    }




  }

  if (e.target.name === "confirmPassword") {

    setPartnerSignupInputValues({
      ...partnerSignupInputValues,
      confirmPassword: e.target.value,
    });

    if (e.target.value.length < 8) {
      setPartnerConfirmPasswordErrorMessage("Confirm password must match the password field");
      return
    } else if (e.target.value !== partnerSignupInputValues.password) {
      setPartnerConfirmPasswordErrorMessage("Confirm password must match the password field");
      return
    } else {
      setPartnerConfirmPasswordErrorMessage("");
    }
  }



  setPartnerSignupInputValues({
    ...partnerSignupInputValues,
    [e.target.name]: e.target.value,
  });
};

const onClickOne = () => {
  setShowPassword(!showPassword);
};

const onClickTwo = () => {
  setShowConfirmPassword(!showConfirmPassword);
};

return (
  <>
    <form
      className="row signup-forms partner-signup-page"
      ref={formRef}
      onSubmit={handleCreateAccount}
    >
      {employerSignupInputFields.map((inputField) => {
        return (
          <React.Fragment key={inputField.id}>
            {inputField.name === "mobileNumber" ? (
              <div className="col-md-6 mt-2 ">
                <div className="form-floating">
                  <PhoneInput
                    id="floatingInput"
                    specialLabel="Mobile Number"
                    country={dialCode === "" ? "us" : dialCode}
                    dataTestid="mobileNumber"
                    countryCodeEditable={false}
                    enableSearch
                    onChange={(e, phone) =>
                      handlePhoneInput(e, phone, "contactno")
                    }
                    value={`${dialCode}${partnerSignupInputValues.mobileNumber}`}
                    inputProps={{
                      alt: "mobileNumber",
                      type: "tel",
                      placeholder: "Mobile Number",
                      required: true,
                    }}
                  />

                </div>

                <div
                  id="signup-error-message"
                  className="text-danger mt-2 signup-error-message professional-signup-error-message"
                >
                  {inputField.errorMessage}
                </div>
              </div>
            ) :
              inputField.name === "typeOfPartner" ? (
                <div className="col-md-6 mt-2 typeOfPartner-field ">
                  <div className="form-floating">
                    <div className="dropdown custom-dropdown">
                      <button
                        className="btn btn-secondary  dropdown-toggle w-100 p-3"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {partnerSignupInputValues.typeOfPartner === "" ? (
                          <span className="signup-placeholder-text">
                            Select type of partner
                          </span>
                        ) : (
                          <span className="text-custom-black">
                            {partnerSignupInputValues.typeOfPartner.length > 20 ? `${partnerSignupInputValues.typeOfPartner.slice(0, 20)}..` : partnerSignupInputValues.typeOfPartner}
                          </span>
                        )}
                      </button>
                      <ul className="dropdown-menu">
                        {typesOfPartner.map((type) => {
                          return (
                            <React.Fragment key={type.id}>
                              <li
                                onClick={() =>
                                  handleTypeOfPartner(type.type)
                                }
                              >
                                <a className="dropdown-item text-custom-black text-wrap">
                                  {type.type}
                                </a>
                              </li>
                            </React.Fragment>
                          );
                        })}
                      </ul>
                      <label className="special-label ">
                        Type of partner<span className="asterisk">&nbsp;*</span>
                      </label>
                    </div>
                  </div>
                </div>
              ) :
                inputField.name === "industrySector" ? (
                  <div className="col-md-6 mt-2 typeOfOrganization-field industry-sectors">
                    <div className="form-floating">
                      <div className="dropdown custom-dropdown">
                        <button
                          className="btn btn-secondary dropdown-toggle w-100 p-3"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {partnerSignupInputValues.industrySector === "" ? (
                            <span className="signup-placeholder-text" >
                              Select your industry
                            </span>
                          ) : (
                            <span className="text-custom-black">
                              {partnerSignupInputValues.industrySector.length > 25 ? `${partnerSignupInputValues.industrySector.slice(0, 25)}..` : `${partnerSignupInputValues.industrySector}`}

                            </span>
                          )}
                        </button>
                        <ul className="dropdown-menu">
                          {industrySectors.map((industry) => {
                            return (
                              <React.Fragment key={industry.id}>
                                <li
                                  onClick={() =>
                                    handleIndustrySector(industry.industry)
                                  }
                                >
                                  <a className="dropdown-item text-custom-black text-wrap">
                                    {industry.industry}
                                  </a>
                                </li>
                              </React.Fragment>
                            );
                          })}
                        </ul>
                        <label className="special-label">Industry Sector<span className="asterisk">&nbsp;*</span></label>
                      </div>
                    </div>
                  </div>
                ) :

                  inputField.name === "location" ? (
                    <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mt-2 location-field-container mb-3">
                      <div className={`form-floating ${locationFieldEmpty ? "border-red" : ""}`}>
                        <Location
                          location={location}
                          setLocation={setLocation}
                          handleLocation={handleLocation}
                          pattern={inputField.pattern}
                          submitted={submitted}
                          formInputFieldError={
                            (location.country.length && location.city.length) >= 3
                              ? ""
                              : inputField.errorMessage
                          }
                          allFieldsEmpty={allFieldsEmpty}
                          setAllFieldsEmpty={setAllFieldsEmpty}
                        />
                      </div>
                    </div>
                  ) :
                    (
                      <FormInput
                        formInputDivClassName={
                          inputField.name === "officialEmail"
                            ? "col-md-6 col-lg-6 col-xl-6 col-xxl-6 mt-2"
                            : inputField.name === "website" ?
                              "col-md-6 mt-2" : "col-md-6 mt-2"
                        }
                        formInputType={inputField.type}
                        formInputId={inputField.name}
                        formAriaLabel={inputField.name}
                        formFieldName={inputField.label}
                        formInputFieldError={inputField.errorMessage}
                        formFieldRequired={true}
                        nameFromProfessionalSignup={inputField.name}
                        valueFromProfessionalSignup={
                          partnerSignupInputValues[inputField.name]
                        }
                        onChange={onChange}
                        errorMessage={inputField.errorMessage}
                        pattern={inputField.pattern}
                        dataTestid={inputField.dataTestid}
                        role={inputField.role}
                        alt={inputField.alt}
                        handleEyeClick={
                          inputField.name === "password"
                            ? onClickOne
                            : null || inputField.name === "confirmPassword"
                              ? onClickTwo
                              : null
                        }
                        showPassword={
                          inputField.name === "password"
                            ? showPassword
                            : null || inputField.name === "confirmPassword"
                              ? showConfirmPassword
                              : null
                        }
                        submitted={submitted}
                        setSubmitted={setSubmitted}
                        allFieldsEmpty={allFieldsEmpty}
                        setAllFieldsEmpty={setAllFieldsEmpty}
                        emailAutoFocus={emailAutoFocus}
                        passwordErrorMessage={partnerPasswordErrorMessage}
                        setPasswordErrorMessage={setPartnerPasswordErrorMessage}
                        confirmPasswordErrorMessage={partnerConfirmPasswordErrorMessage}
                        setConfirmPasswordErrorMessage={setPartnerConfirmPasswordErrorMessage}
                        isPartnerSignup={isPartnerSignup}
                      />
                    )

            }
          </React.Fragment>
        );
      })}

      <div className="col-12 mt-2">
        <div className="form-check">
          <Input
            className="form-check-input"
            type="checkbox"
            id="termsAndCondition"
            required={true}
            alt="checkbox"
            functionOnchange={(e) => setAgreeTerms(e.target.checked)}
            consentText={
              <>
                I agree to all the&nbsp;
                <a onClick={() => window.open("https://www.2ndcareers.com/terms-conditions", "_blank")} className="text-decoration-none">
                  Terms&nbsp;
                </a>
                and&nbsp;
                <a onClick={() => window.open("https://www.2ndcareers.com/privacypolicy", "_blank")} className="text-decoration-none">
                  Privacy policy
                </a>
              </>
            }
          />
        </div>
      </div>

      <div className="d-grid mt-2">
        <button
          type="submit"
          className="btn btn-brand-color"
          disabled={loading}
        >
          {loading ? "Loading..." : "Create Account"}
        </button>



      </div>
    </form>



    <div type="button" id="coutryLocationMatchModalOpen" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#coutryLocationMatchModal">
      Launch demo modal
    </div>


    <div className="modal fade" id="coutryLocationMatchModal" tabIndex="-1" aria-labelledby="coutryLocationMatchModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-bottom-0">
            <h1 className="modal-title fs-5" id="coutryLocationMatchModal">
              <IoIosInformationCircleOutline className="fs-2 brand-color me-3" />
              Location Confirmation
            </h1>
            <button type="button" className="btn-close opacity-0" id="locationConfirmationModalClose" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body mb-5 ms-3">
            There seems to be a mismatch between your location and phone country code. Do you wish to continue?
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-outline-secondary w-25" data-bs-dismiss="modal">No</button>
            <button type="button" className="btn btn-brand-color w-25" onClick={(e) => handleCreateAccountConfirmation(e)}>Yes</button>
          </div>
        </div>
      </div>
    </div>




  </>
);
};

export default PartnerSignupForm
